import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeTab: 0,
  activeSection: null,
  isEdit: false,
  spendGraphData: null
};

const strategySlice = createSlice({
  name: 'strategySlice',
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },
    setSpendGraphData: (state, action) => {
      state.spendGraphData = action.payload;
    },
    setIsEdit: (state, action) => {
      state.isEdit = action.payload;
    }
  }
});

export const { setActiveTab, setActiveSection, setSpendGraphData, setIsEdit } =
  strategySlice.actions;

export const strategyReducer = strategySlice.reducer;
